import React, { createContext, useContext } from 'react'
import type {
  CreateDocumentRuleSession,
  PendingCreateDocumentRule
} from './createDocument/saveCreateDocumentRule'

export interface NodeEditorContextValue {
  configuredNodeId: string | null
  panelOffset: { x: number; y: number } | null
  setPanelOffset: (offset: { x: number; y: number } | null) => void
  onClose: () => void
  onDeleteNode: (nodeId: string) => void
  onCopyNode: (nodeId: string) => void | Promise<void>
  canCopyNode: (nodeId: string) => boolean
  configSnapshot: Record<string, unknown> | null
  configDraft: Record<string, unknown> | null
  updateDraft: (config: Record<string, unknown>) => void
  revertConfig: () => void
  getPendingCreateDocumentRule: (nodeId: string) => PendingCreateDocumentRule | undefined
  upsertPendingCreateDocumentRule: (draft: PendingCreateDocumentRule) => void
  clearPendingCreateDocumentRule: (nodeId: string) => void
  createDocumentFormDirty: boolean
  revertCreateDocumentForm: () => void
  registerCreateDocumentRuleSession: (session: CreateDocumentRuleSession | null) => void
}

const NodeEditorContext = createContext<NodeEditorContextValue | null>(null)

export const NodeEditorProvider: React.FC<
  NodeEditorContextValue & { children: React.ReactNode }
> = ({ children, ...value }) => (
  <NodeEditorContext.Provider value={value}>{children}</NodeEditorContext.Provider>
)

export const useNodeEditor = (): NodeEditorContextValue => {
  const context = useContext(NodeEditorContext)
  if (!context) {
    throw new Error('useNodeEditor must be used within NodeEditorProvider')
  }
  return context
}
